import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProjectsService } from 'app/main/Services/projects.service';
import { MatTableDataSource,MatPaginator } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { AppGlobals } from 'app/main/app.global';
import { Router, ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-search-transaction',
  templateUrl: './search-transaction.component.html',
  styleUrls: ['./search-transaction.component.scss'],
  providers: [AppGlobals]
})
export class SearchTransactionComponent implements OnInit {
  searchTransactionForm: FormGroup;
  totaltransaction:number;
  dataSource: any;
  show_record:boolean=false;
  quote_id:number;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: string[] = ['id', 'amount', 'status', 'cardholderName', 'creditCardNumber', 'email', 'date'];
  constructor(private _formBuilder: FormBuilder,private router: Router,
    private projectsService: ProjectsService,
    private toastr: ToastrService,private _global: AppGlobals,private route: ActivatedRoute) { }

  ngOnInit() {
    this.quote_id = this.route.snapshot.params['id'];
    this.searchTransactionForm = this._formBuilder.group({
      field_name: ['', Validators.required],
      operator: ['', Validators.required],
      field_value: ['', Validators.required],
    });
  }

  search() {
    let formData = this.searchTransactionForm.value;
    this.show_record=true;
    this.projectsService.searchTransaction(formData)
      .subscribe((response:any) => {
        if (response) {
       
          this.totaltransaction=response.data.length;
         
          this.dataSource = new MatTableDataSource(response.data);
          this.dataSource.paginator = this.paginator;
        }
      }, (error) => {
        this.toastr.error(this._global.errorMessage);
      });
  }

  searchTransaction(){
    if(this.quote_id!=null){
      this.router.navigate(['/pms/transactions/search/'+this.quote_id]);
     }else{
      this.router.navigate(['/pms/transactions/search']);
     }
 
  }

  CreateTransaction(){
    if(this.quote_id!=null){
      this.router.navigate(['/pms/transactions/create/'+this.quote_id]);
     }else{
      this.router.navigate(['/pms/transactions/create']);
     }
    
 
  }

}
